import { createRouter, createWebHistory } from 'vue-router';
import agentRoutes from '../agent/router';
import { agentStore } from '../agent/store';
// import NotFound from '../agent/common/NotFound.vue';
// import Cookies from 'js-cookie';
const routes = [
	{ path: '/', redirect: { name: 'AgentPublicHome' } },
	...agentRoutes,
	{ path: '/:pathMatch(.*)*',  redirect: { name: 'AgentPublicHome' } },
	// { path: '/:pathMatch(.*)*', name: 'NotFound', component: NotFound },
];

const router = createRouter({
	history: createWebHistory(),
	routes,
});

router.beforeEach((to, from, next) => {
	const auth = agentStore();
	if (to.matched.some(record => record.meta.requiresAuth) && !auth.isLoggedIn) {
		next({ name: 'AgentPublicHome' });
	} else {
		next();
	}
});

router.afterEach((to) => {
	document.title = to.meta.title || 'Dreasyfly - Agent';
});

export default router;

